const PrebookMathPlugin = {};

PrebookMathPlugin.install = function (Vue) {

    Vue.prototype.$_toFixed = function(num, limit=2) {
        return +(Math.round(num + `e+${limit}`)  + `e-${limit}`);
    }

    Vue.prototype.$_mathCareer = function(careerMonth) {
        let result = 1;

        if(careerMonth >= 24)
            result = parseInt(careerMonth/12);
        
        return result;
    }
}

export default PrebookMathPlugin;
